import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Workspace from "@/pages/Workspace";
import MaterialDetail from "@/pages/MaterialDetail";
import MixedReview from "@/pages/MixedReview";
import Progress from "@/pages/Progress";
import DailyChallenge from "@/pages/DailyChallenge";
import ExamMode from "@/pages/ExamMode";

function Layout() {
  return (
    <div className="App min-h-screen bg-background">
      <Header />
      <Outlet />
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Workspace />} />
          <Route path="/material/:id" element={<MaterialDetail />} />
          <Route path="/mixed/:subjectId" element={<MixedReview />} />
          <Route path="/progress" element={<Progress />} />
          <Route path="/daily" element={<DailyChallenge />} />
          <Route path="/exam" element={<ExamMode />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
